import React from "react"
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";

const PageBreak = ({logo, alt}) =>  {
    return(
        <div className="page-break">
            <Row>
                <Col xs={12} className="d-none d-print-block">
                    <a href="https://lightcast.io" target="_blank" rel="noopener noreferrer" className="float-end">
                        <Image src={logo} alt={alt} width={200}/>
                    </a>
                </Col>
            </Row>
        </div>
    )
}

export default PageBreak;